<template>
    <div class="screen-number full__screen">
        <div class="screen-number__box-content filter">
            <div class="screen-number__box-content__label">
                <span>{{ getTranslatedText('Select Bet Type') }}</span>
            </div>
            <div :class="['screen-number__select__number', { open: market.open }]" @click="market.open = !market.open">
                <span>{{ market.selectLabel }}</span>
                <img
                    class="screen-number__select__number-icon"
                    :src="require(`@/public/img/${$store.state.config.skin}/arrow.svg`)"
                />
                <div class="screen-number__select__number__list">
                    <div
                        v-for="option in market.list"
                        :class="['screen-number__select__number__item', { active: market.select === option.market_id }]"
                        :key="option.market_id"
                        :value="option.market_id"
                        :style="`background-color: ${option.color}`"
                        @click="onSelectMarket(option)"
                    >
                        <span>
                            {{ getTranslatedText(option.market_name) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="screen-number__box-content number">

            <!-- Bet Options Radio Buttons (Normal / Machine Number) -->
            <div v-if="betOptions.length > 0" class="screen-number__bet-options">
                <div class="screen-number__bet-options__label">
                    <span>{{ getTranslatedText('Select Option') }}</span>
                </div>
                <div class="screen-number__bet-options__list">
                    <div
                        v-for="option in betOptions"
                        :key="option"
                        :class="['screen-number__bet-options__item', { active: marketOption === option }]"
                        @click="onSelectMarketOption(option)"
                    >
                        <div class="screen-number__bet-options__radio">
                            <div v-if="marketOption === option" class="screen-number__bet-options__radio-dot"></div>
                        </div>
                        <span class="screen-number__bet-options__text">
                            {{ getTranslatedText(option === 'machine_number' ? 'Machine Number' : 'Normal') }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="screen-number__box-content-header">
                <p class="screen-number__box-content__select-limit">
                    {{ getTranslatedText(
                        ball.min === ball.max ? 'Select [min] [ball]' : 'Select [min] to [max] balls max',
                        {
                            min: ball.min,
                            max: ball.max,
                            ball: getTranslatedText(ball.min > 1 ? 'balls' : 'ball')
                        }
                    ) }}
                </p>
                <ButtonCommon
                    :isNoHover="true"
                    icon="quickpick"
                    type="error"
                    value="Quick Pick"
                    className="screen-number__box-content__box-button__btn"
                    @on-click-button-common="onClickQuickPick()"
                />
            </div>

            <div
                :class="[
                    'screen-number__box-content__list-number',
                    {
                        large:
                            $store.state.increaseFontSize === KEY_INFO.VALUE_LARGE_INCREASE_FONTSIZE &&
                            $store.state.isCheckFontSize,
                    },
                ]"
            >
                <div
                    v-for="(number, index) in ball.list"
                    :class="[
                        'screen-number__box-content__list-number__item',
                        { active: ball.selected.includes(number) },
                    ]"
                    :key="index"
                    @click="() => onSelectNumber(number)"
                >
                    {{ number }}
                </div>
            </div>
            <div class="screen-number__box-content__value-number">
                <input
                    v-model="ball.text"
                    class="screen-number__input__number"
                    type="text"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    ref="inputValueNumber"
                    autocomplete="off"
                    @blur="onBlurValueBall"
                    @keyup="removeDotDash"
                    @keyup.enter="hideKeypad('inputValueNumber')"
                    :placeholder="getTranslatedText('Choose your number')"
                />
                <ButtonCommon
                    v-if="ball.selected.length > 0"
                    :isNoHover="true"
                    :isDisable="isLoadingButton"
                    type="outline"
                    value="clear"
                    @on-click-button-common="onClearSelectNumber(item)"
                />
            </div>
        </div>
        <div class="screen-number__box-content action">
            <div class="screen-number__box-content__action__top">
                <span class="screen-number__box-content__action__top-title">
                    {{ getTranslatedText('Selected') }}
                </span>
                <div class="screen-number__box-content__action__top-list">
                    <template v-for="(v, i) in ball.selected" :key="i">
                        <div class="screen-number__box-content__action__top-item">
                            {{ v }}
                        </div>
                    </template>
                </div>
            </div>
            <div class="screen-number__box-content__action__bottom">
                <div class="screen-number__footer-action-price">
                    <p class="screen-number__title">
                        {{ getTranslatedText('stake') }}
                    </p>
                    <p class="screen-number__text note">
                        {{
                            getTranslatedText('(minimum [min] - maximum [max])', {
                                min: renderPrice(wager.min, 2),
                                max: renderPrice(wager.max, 2),
                            })
                        }}
                    </p>
                    <input
                        ref="inputPriceTicket"
                        v-model="wager.amount"
                        min="0"
                        max="100"
                        pattern="[0-9]*"
                        inputmode="numeric"
                        class="screen-number__input__number price"
                        v-on:keypress="onlyNumber"
                        @blur="onChangeWager"
                        @keyup="debouncedLog"
                        @keyup.enter="hideKeypad('inputPriceTicket')"
                    />
                    <label v-if="wager.validate.label !== ''" class="screen-number__validate">* {{ wager.validate.label }}</label>
                    <div class="screen-number__box-button-price">
                        <ButtonCommon
                            :value="`+${renderPrice('1000', 0, false)}`"
                            @on-click-button-common="onChangePriceNumber(1000)"
                        />
                        <ButtonCommon
                            :value="`+${renderPrice('10000', 0, false)}`"
                            @on-click-button-common="onChangePriceNumber(10000)"
                        />
                        <ButtonCommon
                            :value="`+${renderPrice('50000', 0, false)}`"
                            @on-click-button-common="onChangePriceNumber(50000)"
                        />
                    </div>
                </div>
                <div class="screen-number__box-content__action">
                    <div class="screen-number__box-content__action-item">
                        <span class="screen-number__text bold">
                            {{ getTranslatedText('No of Events') }}: {{ dataSource.length }}
                        </span>
                    </div>
                    <div class="screen-number__box-content__action-item">
                        <span class="screen-number__text bold">
                            {{ getTranslatedText('Number of lines') }}: {{ ball.combinations }}
                        </span>
                    </div>
                    <div class="screen-number__box-content__action__bottom__total">
                        <span class="screen-number__text bold">
                            {{ getTranslatedText('total') }}
                        </span>
                        <span class="screen-number__box-content__action__bottom__total__price">
                            {{ renderPrice(wager.total, 2) }}
                        </span>
                    </div>
                </div>
                <div class="screen-number__box-content__action__bottom__box-button">
                    <ButtonCommon
                        :isNoHover="true"
                        :isLoading="$store.state.isLoadingAddCart"
                        icon="cart"
                        value="add to cart"
                        @on-click-button-common="onAddToCart()"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { countNumberOfLine, formatPrice, generateCombinations, isArrayEmpty, randomColor, removeDotDash } from '@/utils/utils';
import { KEY_INFO } from '@/constants/store';

import languageMixins from '@/mixins/language-mixins';
import ButtonCommon from '@/components/common/button/button.vue';
import EventBus from '@/utils/EventBus';

export default {
    mixins: [languageMixins],
    components: { ButtonCommon },
    props: {
        dataSource: {
            type: Array,
            default: () => [],
        },
        markets: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            market: {
                list: [],
                select: '',
                selectLabel: '',
                potentialWinnings: 0,
                open: false,
                type: '',
            },
            ball: {
                quantity: 0,
                list: 0,
                selected: [],
                min: 0,
                max: 0,
                combinations: 1,
                combination_picks: 1,
                text: '',
                multiplier: 1,
            },
            wager: {
                total: 0,
                min: 0,
                max: 0,
                amount: 0,
                odds: 0,
                debounceTimer: null,
                validate: {
                    isDisable: false,
                    label: ''
                },
                inputItem: {
                    name: 'terminal',
                    type: 'text',
                    required: true,
                },
            },
            betOptions: [],
            marketOption: 'normal', // Default to 'normal' - single selection
            KEY_INFO
        };
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        ...mapState(['ModulesDailyLotto']),
    },
    watch: {
        'ball.selected'(newVal, oldVal) {
            if (newVal !== oldVal && !isArrayEmpty(newVal)) {
                const isBanker = this.market.selectLabel?.toLowerCase().includes('banker')

                const combinations = newVal.length >= this.ball.combination_picks
                        ? isBanker ? countNumberOfLine(newVal) : generateCombinations(newVal.length, this.ball.combination_picks)
                        : 1;

                this.wager.total = this.wager.amount * combinations * this.ball.multiplier;
                this.ball.combinations = combinations;
            }
            this.renderValueBall();
        },
    },
    methods: {
        fetchData() {
            if (!isArrayEmpty(this.dataSource)) {

                const marketList = this.markets.map((element) => {
                    const color = randomColor(element.market_slug);

                    const item = {
                        ...element,
                        color,
                        ballset: this.dataSource[0].gameConfig?.config?.setup['1']?.ballset || '[1, 90]',
                    }

                    return item
                })
                this.market.list = marketList;
                this.market.select = marketList[0].market_id;
                this.market.selectLabel = marketList[0].market_name;

                // Get bet options from the dataSource gameConfig (not game!)
                this.betOptions = this.dataSource[0]?.gameConfig?.config?.bet_options || [];
                // Default to 'normal' if available
                if (this.betOptions.includes('normal')) {
                    this.marketOption = 'normal';
                } else if (this.betOptions.length > 0) {
                    this.marketOption = this.betOptions[0];
                }

                this.onGetDataSelected(marketList[0]);
            }
        },

        onGetDataSelected(markets) {
            const ballsetArray = JSON.parse(markets.ballset);
            const ballNumber = !isArrayEmpty(ballsetArray) ? ballsetArray[1] : 90;

            this.ball.quantity = parseInt(ballNumber);
            this.ball.list = this.onRenderListBalls();
            this.ball.min = markets.market_config.balls['1']?.picks[0];
            this.ball.max = markets.market_config.balls['1']?.picks[1];
            this.ball.combination_picks = markets.combination_picks
            this.ball.multiplier = markets.market_config?.multiplier || 1;
            this.ball.combinations = 1

            this.wager.min = markets.market_config?.wager?.min || 1;
            this.wager.max = markets.market_config?.wager?.max || 1;
            this.wager.amount = '';
            this.wager.total = 0.00;
            this.wager.odds = markets?.odds || 1;
            this.market.selectLabel = markets.market_name;
            this.market.select = markets.market_id;
            this.market.type = markets.type;

            this.ball.selected = [];
        },

        onRenderListBalls() {
            const balls = this.ball.quantity;
            const listBalls = Array.from({ length: balls }, (_, i) => i + 1);
            return listBalls;
        },

        // ACTION BALL
        onSelectNumber(number) {
            const selection = this.ball.selected;
            if (this.ball.max > selection.length) {
                const index = selection.findIndex((x) => x === number);
                if (index !== -1) selection.splice(index, 1);
                else selection.push(number);
                this.ball.selected = [...selection];
            } else {
                const index = selection.findIndex((x) => x === number);
                if (index !== -1) {
                    selection.splice(index, 1);
                    this.ball.selected = [...selection];
                }
            }
        },

        onClickQuickPick() {
            let numbers = this.onRenderListBalls();
            let min = this.ball.min;

            numbers.sort(() => Math.random() - 0.5);
            numbers = [...numbers.slice(0, min)];

            this.ball.selected = [...numbers];
        },

        onClearSelectNumber() {
            this.ball.selected = [];
            this.ball.combinations = 1
            this.wager.amount = '';
            this.wager.total = 0.00;
            this.wager.potentialWinnings = 0
        },

        renderTextTickets(arr) {
            let valueBallRender = '';
            arr.forEach((x, index) => {
                valueBallRender = `${valueBallRender}${index !== 0 ? ',' : ''} ${x}`;
            });
            return valueBallRender;
        },

        renderValueBall() {
            const selection = [...this.ball.selected];
            const numberSelect = selection.sort((a, b) => a - b);

            this.ball.text = this.renderTextTickets(numberSelect);
        },

        onBlurValueBall() {
            const { list, max } = this.ball;
            let inputArray = this.ball.text
                .split(',')
                .map((num) => Number(num.trim()))
                .filter((num, index, self) => num >= 1 && num <= list.length && index === self.indexOf(num));

            inputArray = inputArray.slice(0, max);
            this.ball.text = inputArray.join(',');
            this.ball.selected = [...inputArray];
        },

        removeDotDash() {
            this.ball.text = removeDotDash(this.ball.text)
        },

        // ACTION WAGER
        debouncedLog() {
            clearTimeout(this.wager.debounceTimer);
            const numericValue = this.wager.amount ? parseInt(this.wager.amount) : 0;

            this.wager.total = parseFloat(numericValue) * this.ball.combinations * this.ball.multiplier;
            this.wager.validate.isDisable = true
            this.wager.debounceTimer = setTimeout(() => {

                if (numericValue < this.wager.min) {
                    this.wager.validate.isDisable = true
                    this.wager.validate.label = this.getTranslatedText(`Please re-enter, the minimum is [price]`, {
                        price: this.renderPrice(this.wager.min, 2)
                    })
                } else if (numericValue > this.wager.max) {
                    this.wager.validate.isDisable = true
                    this.wager.validate.label = this.getTranslatedText(`Please re-enter, the maximum is [price]`, {
                        price: this.renderPrice(this.wager.max, 2)
                    })
                } else {
                    this.wager.validate.isDisable = false
                    this.wager.validate.label = ''
                }

            }, 300);
        },

        onChangeWager(event) {
            const { value } = event.target;
            const numericValue = value ? parseInt(value) : 0;

            if (numericValue < this.wager.min) {
                this.wager.amount = this.wager.min;
            } else if (numericValue > this.wager.max) {
                this.wager.amount = this.wager.max;
            } else {
                this.wager.amount = Math.floor(value / this.wager.min) * this.wager.min;
            }

            this.wager.total = this.wager.amount * this.ball.combinations * this.ball.multiplier
            this.wager.validate.isDisable = false
            this.wager.validate.label = ''
            this.debouncedLog()
        },

        onChangePriceNumber(price) {
            const priceInput = parseFloat(this.wager.amount || 0);
            let priceMore = priceInput + price;
            if (priceMore > this.wager.max) {
                priceMore = this.wager.max;
            }
            this.wager.amount = priceMore;
            this.wager.total = priceMore * this.ball.combinations * this.ball.multiplier
        },

        //Market
        onSelectMarket(market) {
            const marketSelect = this.market.list.filter((x) => x.market_id === market.market_id);
            if (!isArrayEmpty(marketSelect)) {
                this.onGetDataSelected(marketSelect[0]);
            }
        },
        // add to cart
        onAddToCart() {
            if (this.ball.min > this.ball.selected.length) {
                const param = {
                    text: this.getTranslatedText(`Please make sure that you select [number] of balls!`, {
                        number: this.ball.min,
                    }),
                    type: 'warning',
                };
                EventBus.emit('show-notications', param);

                return false;
            }

            if(!this.wager.amount) {
                const param = {
                    text: this.getTranslatedText(`Stake amount not entered`),
                    type: 'warning',
                };
                EventBus.emit('show-notications', param);

                return false;
            }

            const index = this.market.list.findIndex((x) => x.market_id === this.market.select);
            if (index !== -1) {
                this.wager.potentialWinnings = this.wager.amount * this.wager.odds * this.ball.combinations;
                const selected = this.market.list[index];

                const payloadCart = []
                this.dataSource.forEach((element) => {
                    const itemAddCart = {
                        id: new Date()
                            .getTime()
                            .toString(36)
                            .concat(performance.now().toString(), Math.random().toString())
                            .replace(/\./g, ''),
                        date: element.draw_date,
                        slug: element.game_slug,
                        game: element.game,
                        marketName: selected.market_name,
                        marketSlug: selected.market_slug,
                        selection: this.ball.selected,
                        price: parseInt(this.wager.amount),
                        potentialWinnings: this.wager.potentialWinnings,
                        combinations: this.ball.combinations,
                        multiplier: this.ball.multiplier,
                        type: element.type,
                        draw_name: element.draw_name,
                        raffle_promotion_id: element.raffle_promotion_id,
                        market_option: this.marketOption, // Add selected market option (normal or machine_number)
                    };

                    payloadCart.push(itemAddCart)
                })

                this.$store.dispatch('ModulesDailyLotto/actionAddToCart', payloadCart);
                this.onClearSelectNumber();
            }
        },

        // format
        renderPrice(price, decimal = 0, isShowCurrency = true) {
            const priceReplace = parseFloat(price.toString().replace(/,/g, ''));
            const priceFormat = isShowCurrency
                ? `${this.$store.state.config.setup.currency} ${formatPrice(priceReplace, decimal)}`
                : formatPrice(priceReplace, decimal)
            return priceFormat;
        },
        hideKeypad(ref) {
            this.$refs[ref].blur();
        },

        onlyNumber(event) {
            if (event.key === '-' && event.target.selectionStart !== 0) {
                event.preventDefault();
                return;
            }
            if (event.keyCode < 48 || event.keyCode > 57) {
                event.preventDefault();
            }
        },

        // Select market option (radio button behavior - single selection)
        onSelectMarketOption(option) {
            this.marketOption = option;
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/number.scss';
</style>

